import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=2cc50341"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports